<section class="login-block">
  <!-- Container-fluid starts -->
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <!-- Authentication card start -->
          <div class="text-center">
            <img class="header-logo" src="../../../assets/images/urbansofa_logo_white.png" alt="logo.png">
          </div>
          <div class="auth-box card">
            <div class="card-block">
              <div class="row m-b-20">
                <div class="col-md-12">
                  <p class="text-justify">{{ 'validators.reset_password.line1' | translate }}</p>
                  <p class="text-justify">{{ 'validators.reset_password.line2' | translate }}</p>
                </div>
              </div>
              <div class="row m-t-25">
                <div class="col-12">
                  <div class="forgot-phone text-center">
                    <a [routerLink]="['/login']" class="btn btn-primary btn-md text-center m-b-20 ripple light"> {{'auth.singin.title'|translate}}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        <!-- end of form -->
      </div>
      <!-- end of col-sm-12 -->
    </div>
    <!-- end of row -->
  </div>
  <!-- end of container-fluid -->
</section>
